interface TutorialContent {
  filename: string;
  filetype: string;
  link: string;
  path: string;
  title: string;
}

const loadingData = [
  {
    "filename": "",
    "filetype": "",
    "link": "#",
    "path": "",
    "title": "Loading..."
  },
  {
    "filename": "",
    "filetype": "",
    "link": "#",
    "path": "",
    "title": "Loading..."
  }
];

const errorData = [
  {
    "filename": "",
    "filetype": "",
    "link": "#",
    "path": "",
    "title": "Could not load content, please reload the page in a few moments."
  }
];

export { TutorialContent, loadingData, errorData };